<template>
  <div class="brand-tile">
    <router-link
      :data-test-id="`tile_link_brand-image`"
      :to="`/brands/${brand.vanity_url_name}?page=1&sortBy=created_at_asc`"
    >
      <template>
        <img
          v-if="brand.thumbnail_image_url"
          :class="{ bordered: bordered }"
          :src="`https://bulletin.co/cdn-cgi/image/width=556,quality=100,format=auto/${brand.thumbnail_image_url}`"
          alt="brand thumbnail"
        />

        <div v-else class="image-placeholder" :class="{ bordered: bordered }" />
      </template>

      <div class="brand-name-row flex align-center justify-between">
        <h3 class="brand-name font-size-24 text-overflow-ellipsis overflow-hidden">{{ brand.brand_name }}</h3>
        <follow-button :brand-id="brand.id" />
      </div>

      <div class="mov-value">
        {{ (brand.minimum_order_value ? `$${brand.minimum_order_value}` : "no") + " minimum" }}
      </div>
    </router-link>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/sass/base/_vars.scss";
@import "@/assets/sass/base/_mixins.scss";
.brand-tile {
  img,
  .image-placeholder {
    width: 100%;
    background-color: #f5f5f5;
    height: calc(calc(calc(100vw - 142px) / 4) * 1.25);
    object-fit: cover;

    @include respond-to("medium") {
      height: 110vw;
    }

    &.bordered {
      border: 1px solid black;
    }
  }

  .brand-name-row {
    margin-top: 16px;

    .brand-name {
      max-width: calc(25vw - 150px);

      @include respond-to("medium") {
        max-width: calc(100vw - 150px);
      }
    }
  }
  .mov-value {
    font-family: "NHaasGroteskDSPro-55Rg";
    font-size: 12px;
    line-height: 20px;
    color: $secondaryGrey4;
  }
}
</style>

<script>
import FollowButton from "../TheDiscoveryFeed/TheFollowButton";

export default {
  components: { FollowButton },
  props: {
    brand: {
      type: Object,
    },
    bordered: {
      type: Boolean,
    },
  },
};
</script>
